/* Cartwala single visible CTA — preview theme only */
(function () {
  "use strict";
  if (window.__cartwalaSingleCTA) return;
  window.__cartwalaSingleCTA = true;

  function init() {
    var scope = document.querySelector(".product-layout") || document.querySelector("main#MainContent");
    if (!scope) return;
    var form = scope.querySelector("form[data-main-add-to-cart], form[action*='/cart/add']");
    if (!form) return;

    var footer = document.createElement("div");
    footer.className = "cw-single-action-footer";
    footer.setAttribute("aria-label", "Product purchase options");
    footer.setAttribute("aria-hidden", "true");
    footer.innerHTML =
      '<div class="cw-single-action-price" aria-live="polite"></div>' +
      '<div class="cw-single-action-qty" aria-label="Quantity">' +
      '<button type="button" data-cw-qty-minus aria-label="Decrease quantity">−</button>' +
      '<span data-cw-qty-number>1</span>' +
      '<button type="button" data-cw-qty-plus aria-label="Increase quantity">+</button></div>' +
      '<button type="button" class="cw-single-action-button" data-cw-single-action>Customize Now</button>';
    document.body.appendChild(footer);
    document.body.classList.add('cw-single-cta-ready');
    var actionButton = footer.querySelector("[data-cw-single-action]");
    var priceContainer = footer.querySelector(".cw-single-action-price");
    var qtyNumber = footer.querySelector("[data-cw-qty-number]");
    var currentTarget = null;
    var pending = false;
    var lastCleanup = 0;

    function visual(element) {
      if (!element || element.hidden || element.closest("[hidden], dialog, [role='dialog']")) return false;
      var style = getComputedStyle(element);
      if (style.display === "none" || style.visibility === "hidden" || style.opacity === "0") return false;
      var rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }
    function mainButton() {
      return form.querySelector("[data-add-to-cart], button[name='add'], button[type='submit'], input[type='submit']");
    }
    function chosenVariantAvailable() {
      var picker = form.querySelector("[data-variant-picker]");
      var id = form.querySelector("input[name='id']");
      if (picker && picker.dataset.variants && id) {
        try {
          var variants = JSON.parse(picker.dataset.variants);
          var variant = variants.find(function (v) { return String(v.id) === String(id.value); });
          if (variant && typeof variant.available === "boolean") return variant.available;
        } catch (e) { /* Preserve storefront operation if variant JSON is invalid. */ }
      }
      var add = mainButton();
      if (add && /^sold out$/i.test((add.textContent || add.value || "").trim())) return false;
      return true;
    }
    function customizeButton() {
      var named = Array.prototype.slice.call(scope.querySelectorAll(
        ".cw-personalizer__open, [data-cw-open], [data-personalize-open], [data-customize-now]"
      )).find(visual);
      if (named) return named;
      return Array.prototype.slice.call(scope.querySelectorAll("button, a[role='button']")).find(function (button) {
        if (button.closest(".cw-single-action-footer, .sticky-atc, [data-sticky-atc], .shopify-payment-button")) return false;
        if (!visual(button)) return false;
        return /^(customi[sz]e now|personalise now|personalize now|edit again)$/i.test((button.textContent || "").trim());
      }) || null;
    }
    function decide() {
      var add = mainButton();
      var custom = customizeButton();
      var inStock = chosenVariantAvailable();
      if (!inStock) return { kind: "sold", anchor: visual(add) ? add : custom, target: null, label: "Sold Out" };
      // A disabled/hidden Add to Cart is not a sold-out product: the editor comes first.
      if (visual(add) && !add.disabled) return {
        kind: "add", anchor: add, target: add, label: "Add to Cart"
      };
      if (custom) return { kind: "custom", anchor: custom, target: custom, label: "Customize Now" };
      if (visual(add)) return {
        kind: "add", anchor: add, target: add,
        label: add.disabled ? "Adding…" : "Add to Cart"
      };
      return null;
    }
    /* cw-sticky-race-v3: third-party/legacy sticky detection, including Customise First. */
    function cartIsOpen() {
      return !!document.querySelector(
        "#cart-drawer.is-open, #CartDrawer.is-open, .cart-drawer.is-open, " +
        "[data-cart-drawer].is-open, [data-cart-drawer][open]"
      );
    }
    function hideOtherBars(force) {
      var selectors = "[data-sticky-atc], .sticky-atc, .sticky-add-to-cart, " +
        "[class*='sticky'][class*='cart'], [id*='sticky'][id*='cart'], " +
        "[class*='bottom'][class*='atc']";
      Array.prototype.forEach.call(document.querySelectorAll(selectors), function (el) {
        if (el !== footer && !footer.contains(el) &&
            !el.closest("#cart-drawer, #CartDrawer, .cw-personalizer__dialog") &&
            !el.hasAttribute("data-cw-legacy-sticky")) {
          el.setAttribute("data-cw-legacy-sticky", "");
        }
      });

      var now = Date.now();
      if (!force && now - lastCleanup < 140) return;
      lastCleanup = now;
      var candidates = document.querySelectorAll("button, a[role='button'], [role='button']");
      Array.prototype.forEach.call(candidates, function (button) {
        if (footer.contains(button) ||
            button.closest("#cart-drawer, #CartDrawer, .cw-personalizer__dialog, dialog, [role='dialog']")) return;
        var label = (button.textContent || "").replace(/\s+/g, " ").trim();
        if (!/(?:add\s+to\s+cart|sold\s+out|customi[sz]e\s+(?:now|first)|personaliz(?:e|ation)\s+first)/i.test(label)) return;
        var ancestor = button;
        for (var depth = 0; ancestor && depth < 10 && ancestor !== document.body; depth++, ancestor = ancestor.parentElement) {
          if (ancestor === footer || ancestor.contains(footer)) break;
          if (ancestor.closest("#cart-drawer, #CartDrawer, .cw-personalizer__dialog, dialog")) break;
          var position = getComputedStyle(ancestor).position;
          if (position !== "fixed" && position !== "sticky") continue;
          var rect = ancestor.getBoundingClientRect();
          if (rect.width >= innerWidth * 0.43 && rect.top > innerHeight * 0.37 &&
              rect.top < innerHeight + 70 && rect.bottom >= innerHeight - 110) {
            if (!ancestor.hasAttribute("data-cw-legacy-sticky"))
              ancestor.setAttribute("data-cw-legacy-sticky", "");
            break;
          }
        }
      });
    }
    function sync() {
      pending = false;
      var cartOpen = cartIsOpen();
      hideOtherBars(cartOpen);
      var state = decide();
      currentTarget = state;
      var modalOpen = cartOpen || !!document.querySelector(
        ".cw-personalizer__dialog[open], dialog[open], [data-cw-mug-dialog][open]"
      );
      document.body.classList.toggle("cw-cart-panel-open", cartOpen);
      var visibleInView = false;
      [state && state.anchor, mainButton(), customizeButton()].forEach(function (element) {
        if (!visual(element)) return;
        var bounds = element.getBoundingClientRect();
        if (bounds.bottom > 0 && bounds.top < innerHeight) visibleInView = true;
      });
      var show = !!(state && state.anchor && !visibleInView && !modalOpen && innerWidth < 960);
      footer.classList.toggle("is-active", show);
      footer.setAttribute("aria-hidden", show ? "false" : "true");
      footer.inert = !show;
      if (!state) return;
      if (actionButton.textContent !== state.label) actionButton.textContent = state.label;
      actionButton.disabled = state.kind === "sold" ||
        (state.kind === "add" && state.target && state.target.disabled);
      if (actionButton.dataset.action !== state.kind) actionButton.dataset.action = state.kind;
      var originalPrice = scope.querySelector(".product-info__price") ||
        scope.querySelector("[data-product-price]");
      if (originalPrice) {
        var priceNode = originalPrice.querySelector(".price__sale") ||
          originalPrice.querySelector(".price > span:not(.price__compare):not(.badge)") ||
          originalPrice.querySelector(".price");
        var originalText = priceNode ? priceNode.textContent : originalPrice.textContent;
        var cleanPrice = (originalText || "").replace(/\s+/g, " ").trim()
          .replace(/^(?:Rs\\.?|INR)\s*/i, "₹")
          .replace(/\\.00(?=\s*$)/, "");
        if (priceContainer.textContent !== cleanPrice) priceContainer.textContent = cleanPrice;
      }
      var qty = form.querySelector("input[name='quantity']");
      var displayQty = qty ? String(qty.value || "1") : "1";
      if (qtyNumber.textContent !== displayQty) qtyNumber.textContent = displayQty;
    }
    function schedule() {
      if (!pending) { pending = true; requestAnimationFrame(sync); }
    }
    actionButton.addEventListener("click", function (event) {
      event.preventDefault();
      var state = decide();
      if (!state || state.kind === "sold" || !state.target || !visual(state.target)) return;
      state.target.click();
      schedule();
    });
    footer.querySelector("[data-cw-qty-minus]").addEventListener("click", function () { adjust(-1); });
    footer.querySelector("[data-cw-qty-plus]").addEventListener("click", function () { adjust(1); });
    function adjust(delta) {
      var input = form.querySelector("input[name='quantity']");
      if (!input) return;
      var min = Math.max(1, Number(input.min) || 1);
      var max = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(max, Math.max(min, (parseInt(input.value, 10) || 1) + delta)));
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
      schedule();
    }
    var observer = new MutationObserver(schedule);
    observer.observe(scope, {
      subtree: true, childList: true, attributes: true, characterData: true,
      attributeFilter: ["hidden", "style", "class", "disabled", "aria-hidden", "value"]
    });
    var drawer = document.querySelector("#cart-drawer");
    if (drawer) new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ["class", "aria-hidden"] });
    var bodyObserver = new MutationObserver(function (records) {
      // Watch delayed app sticky injection without triggering on our footer's changes.
      if (records.some(function (record) { return !footer.contains(record.target); })) schedule();
    });
    bodyObserver.observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ["class", "style", "hidden", "aria-hidden"]
    });
    window.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule, { passive: true });
    document.addEventListener("change", schedule, true);
    document.addEventListener("cartwala:personalization-saved", schedule);
    document.addEventListener("shopify:section:load", schedule);
    schedule();
    setTimeout(schedule, 500);
    setTimeout(schedule, 1800);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();